import { generateParams } from 'features/filters/filtersSlice';

import { get, post } from 'utils/api/api';

import { Location } from 'types/commons';
import { Filters } from 'types/filters';
import {
  RecruitmentOverviewClosedHiresList,
  RecruitmentOverviewReportJobsList,
  RecruitmentOverviewReportStatistics
} from 'types/reports';

import {
  CLOSED_HIRES,
  RECRUITMENT_OVERVIEW_REPORT_CITIES,
  RECRUITMENT_OVERVIEW_REPORT_JOBS,
  RECRUITMENT_OVERVIEW_REPORT_STAT
} from 'constants/endpoints';
import { MAX_ITEMS_TO_GET } from 'constants/uiSettings';

class ReportsService {
  async getRecruitmentOverviewReportCities(): Promise<Location[]> {
    const res = await get(`${RECRUITMENT_OVERVIEW_REPORT_CITIES}`);
    return res;
  }

  async getRecruitmentOverviewReportStatistics({
    days,
    locations
  }: {
    days?: number;
    locations?: Location[];
  }): Promise<RecruitmentOverviewReportStatistics> {
    const res = await post(`${RECRUITMENT_OVERVIEW_REPORT_STAT}`, {
      locations,
      days
    });
    return res;
  }

  async getRecruitmentOverviewReportJobs(
    filters: Filters
  ): Promise<RecruitmentOverviewReportJobsList> {
    const res = await post(`${RECRUITMENT_OVERVIEW_REPORT_JOBS}`, filters);
    return res;
  }

  async getRecruitmentOverviewReportClosedHires({
    days,
    jobId
  }: {
    days?: number;
    jobId: string;
  }): Promise<RecruitmentOverviewClosedHiresList> {
    const params = generateParams({
      page: 0,
      pageSize: MAX_ITEMS_TO_GET,
      days
    });
    const res = await get(
      `${RECRUITMENT_OVERVIEW_REPORT_JOBS}/${jobId}/${CLOSED_HIRES}${params}`
    );
    return res;
  }
}

export default new ReportsService();
